import { AxiosRequestConfig } from 'axios';
import { createMockedAxios } from '@domain/services/remote/remote.services.mock';
import { GameInfo } from '@domain/game.selection/types/game.info';

function getDefaultSettings(game: GameInfo): AxiosRequestConfig {
  return {
    baseURL: game.baseUrl,
  };
}

export function createRemoteServices(game: GameInfo, authToken: string | undefined, unauthorizedCallback: () => void) {
  const defaults = getDefaultSettings(game);

  if (!authToken) {
    return createMockedAxios(defaults);
  }

  const newAuthorizedServices = createMockedAxios({
    ...defaults,
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });

  newAuthorizedServices.interceptors.response.use(undefined, (error) => {
    if (error && error.response && error.response.status === 401) {
      unauthorizedCallback();
    }
    return Promise.reject(error);
  });

  return newAuthorizedServices;
}
